/**
 * field input phone
 */
export const fieldInputPhone = {
  name: 'name_input_phone',
  value: '',
};

export const customPhonePrefixList = [
  { code: '+93', value: 'AF', name: 'AF - Afghanistan (+93)' },
  { code: '+355', value: 'AL', name: 'AL - Albania (+355)' },
  { code: '+213', value: 'DZ', name: 'DZ - Algeria (+213)' },
  { code: '+1-684', value: 'AS', name: 'AS - American Samoa (+1-684)' },
  { code: '+376', value: 'AD', name: 'AD - Andorra (+376)' },
  { code: '+244', value: 'AO', name: 'AO - Angola (+244)' },
  { code: '+1-264', value: 'AI', name: 'AI - Anguilla (+1-264)' },
  { code: '+672', value: 'AQ', name: 'AQ - Antarctica (+672)' },
  { code: '+1-268', value: 'AG', name: 'AG - Antigua and Barbuda (+1-268)' },
  { code: '+54', value: 'AR', name: 'AR - Argentina (+54)' },
  { code: '+374', value: 'AM', name: 'AM - Armenia (+374)' },
  { code: '+297', value: 'AW', name: 'AW - Aruba (+297)' },
  { code: '+61', value: 'AU', name: 'AU - Australia (+61)' },
  { code: '+43', value: 'AT', name: 'AT - Austria (+43)' },
  { code: '+994', value: 'AZ', name: 'AZ - Azerbaijan (+994)' },
  { code: '+1-242', value: 'BS', name: 'BS - Bahamas (+1-242)' },
  { code: '+973', value: 'BH', name: 'BH - Bahrain (+973)' },
  { code: '+880', value: 'BD', name: 'BD - Bangladesh (+880)' },
  { code: '+1-246', value: 'BB', name: 'BB - Barbados (+1-246)' },
  { code: '+375', value: 'BY', name: 'BY - Belarus (+375)' },
  { code: '+32', value: 'BE', name: 'BE - Belgium (+32)' },
  { code: '+501', value: 'BZ', name: 'BZ - Belize (+501)' },
  { code: '+229', value: 'BJ', name: 'BJ - Benin (+229)' },
  { code: '+1-441', value: 'BM', name: 'BM - Bermuda (+1-441)' },
  { code: '+975', value: 'BT', name: 'BT - Bhutan (+975)' },
  { code: '+591', value: 'BO', name: 'BO - Bolivia (+591)' },
  { code: '+387', value: 'BA', name: 'BA - Bosnia and Herzegovina (+387)' },
  { code: '+267', value: 'BW', name: 'BW - Botswana (+267)' },
  { code: '+55', value: 'BR', name: 'BR - Brazil (+55)' },
  { code: '+246', value: 'IO', name: 'IO - British Indian Ocean Territory (+246)' },
  { code: '+1-284', value: 'VG', name: 'VG - British Virgin Islands (+1-284)' },
  { code: '+673', value: 'BN', name: 'BN - Brunei (+673)' },
  { code: '+359', value: 'BG', name: 'BG - Bulgaria (+359)' },
  { code: '+226', value: 'BF', name: 'BF - Burkina Faso (+226)' },
  { code: '+257', value: 'BI', name: 'BI - Burundi (+257)' },
  { code: '+855', value: 'KH', name: 'KH - Cambodia (+855)' },
  { code: '+237', value: 'CM', name: 'CM - Cameroon (+237)' },
  { code: '+1', value: 'CA', name: 'CA - Canada (+1)' },
  { code: '+238', value: 'CV', name: 'CV - Cape Verde (+238)' },
  { code: '+1-345', value: 'KY', name: 'KY - Cayman Islands (+1-345)' },
  { code: '+236', value: 'CF', name: 'CF - Central African Republic (+236)' },
  { code: '+235', value: 'TD', name: 'TD - Chad (+235)' },
  { code: '+56', value: 'CL', name: 'CL - Chile (+56)' },
  { code: '+86', value: 'CN', name: 'CN - China (+86)' },
  { code: '+61', value: 'CX', name: 'CX - Christmas Island (+61)' },
  { code: '+61', value: 'CC', name: 'CC - Cocos Islands (+61)' },
  { code: '+57', value: 'CO', name: 'CO - Colombia (+57)' },
  { code: '+269', value: 'KM', name: 'KM - Comoros (+269)' },
  { code: '+682', value: 'CK', name: 'CK - Cook Islands (+682)' },
  { code: '+506', value: 'CR', name: 'CR - Costa Rica (+506)' },
  { code: '+385', value: 'HR', name: 'HR - Croatia (+385)' },
  { code: '+53', value: 'CU', name: 'CU - Cuba (+53)' },
  { code: '+599', value: 'CW', name: 'CW - Curacao (+599)' },
  { code: '+357', value: 'CY', name: 'CY - Cyprus (+357)' },
  { code: '+420', value: 'CZ', name: 'CZ - Czech Republic (+420)' },
  { code: '+243', value: 'CD', name: 'CD - Democratic Republic of the Congo (+243)' },
  { code: '+45', value: 'DK', name: 'DK - Denmark (+45)' },
  { code: '+253', value: 'DJ', name: 'DJ - Djibouti (+253)' },
  { code: '+1-767', value: 'DM', name: 'DM - Dominica (+1-767)' },
  { code: '+1-809', value: 'DO', name: 'DO - Dominican Republic (+1-809)' },
  { code: '+1-829', value: 'DO1', name: 'DO - Dominican Republic (+1-829)' },
  { code: '+1-849', value: 'DO2', name: 'DO - Dominican Republic (+1-849)' },
  { code: '+670', value: 'TL', name: 'TL - East Timor (+670)' },
  { code: '+593', value: 'EC', name: 'EC - Ecuador (+593)' },
  { code: '+20', value: 'EG', name: 'EG - Egypt (+20)' },
  { code: '+503', value: 'SV', name: 'SV - El Salvador (+503)' },
  { code: '+240', value: 'GQ', name: 'GQ - Equatorial Guinea (+240)' },
  { code: '+291', value: 'ER', name: 'ER - Eritrea (+291)' },
  { code: '+372', value: 'EE', name: 'EE - Estonia (+372)' },
  { code: '+251', value: 'ET', name: 'ET - Ethiopia (+251)' },
  { code: '+500', value: 'FK', name: 'FK - Falkland Islands (+500)' },
  { code: '+298', value: 'FO', name: 'FO - Faroe Islands (+298)' },
  { code: '+679', value: 'FJ', name: 'FJ - Fiji (+679)' },
  { code: '+358', value: 'FI', name: 'FI - Finland (+358)' },
  { code: '+33', value: 'FR', name: 'FR - France (+33)' },
  { code: '+689', value: 'PF', name: 'PF - French Polynesia (+689)' },
  { code: '+241', value: 'GA', name: 'GA - Gabon (+241)' },
  { code: '+220', value: 'GM', name: 'GM - Gambia (+220)' },
  { code: '+995', value: 'GE', name: 'GE - Georgia (+995)' },
  { code: '+49', value: 'DE', name: 'DE - Germany (+49)' },
  { code: '+233', value: 'GH', name: 'GH - Ghana (+233)' },
  { code: '+350', value: 'GI', name: 'GI - Gibraltar (+350)' },
  { code: '+30', value: 'GR', name: 'GR - Greece (+30)' },
  { code: '+299', value: 'GL', name: 'GL - Greenland (+299)' },
  { code: '+1-473', value: 'GD', name: 'GD - Grenada (+1-473)' },
  { code: '+1-671', value: 'GU', name: 'GU - Guam (+1-671)' },
  { code: '+502', value: 'GT', name: 'GT - Guatemala (+502)' },
  { code: '+44-1481', value: 'GG', name: 'GG - Guernsey (+44-1481)' },
  { code: '+224', value: 'GN', name: 'GN - Guinea (+224)' },
  { code: '+245', value: 'GW', name: 'GW - Guinea-Bissau (+245)' },
  { code: '+592', value: 'GY', name: 'GY - Guyana (+592)' },
  { code: '+509', value: 'HT', name: 'HT - Haiti (+509)' },
  { code: '+504', value: 'HN', name: 'HN - Honduras (+504)' },
  { code: '+852', value: 'HK', name: 'HK - Hong Kong (+852)' },
  { code: '+36', value: 'HU', name: 'HU - Hungary (+36)' },
  { code: '+354', value: 'IS', name: 'IS - Iceland (+354)' },
  { code: '+91', value: 'IN', name: 'IN - India (+91)' },
  { code: '+62', value: 'ID', name: 'ID - Indonesia (+62)' },
  { code: '+98', value: 'IR', name: 'IR - Iran (+98)' },
  { code: '+964', value: 'IQ', name: 'IQ - Iraq (+964)' },
  { code: '+353', value: 'IE', name: 'IE - Ireland (+353)' },
  { code: '+44-1624', value: 'IM', name: 'IM - Isle of Man (+44-1624)' },
  { code: '+972', value: 'IL', name: 'IL - Israel (+972)' },
  { code: '+39', value: 'IT', name: 'IT - Italy (+39)' },
  { code: '+225', value: 'CI', name: 'CI - Ivory Coast (+225)' },
  { code: '+1-876', value: 'JM', name: 'JM - Jamaica (+1-876)' },
  { code: '+81', value: 'JP', name: 'JP - Japan (+81)' },
  { code: '+44-1534', value: 'JE', name: 'JE - Jersey (+44-1534)' },
  { code: '+962', value: 'JO', name: 'JO - Jordan (+962)' },
  { code: '+7', value: 'KZ', name: 'KZ - Kazakhstan (+7)' },
  { code: '+254', value: 'KE', name: 'KE - Kenya (+254)' },
  { code: '+686', value: 'KI', name: 'KI - Kiribati (+686)' },
  { code: '+383', value: 'XK', name: 'XK - Kosovo (+383)' },
  { code: '+965', value: 'KW', name: 'KW - Kuwait (+965)' },
  { code: '+996', value: 'KG', name: 'KG - Kyrgyzstan (+996)' },
  { code: '+856', value: 'LA', name: 'LA - Laos (+856)' },
  { code: '+371', value: 'LV', name: 'LV - Latvia (+371)' },
  { code: '+961', value: 'LB', name: 'LB - Lebanon (+961)' },
  { code: '+266', value: 'LS', name: 'LS - Lesotho (+266)' },
  { code: '+231', value: 'LR', name: 'LR - Liberia (+231)' },
  { code: '+218', value: 'LY', name: 'LY - Libya (+218)' },
  { code: '+423', value: 'LI', name: 'LI - Liechtenstein (+423)' },
  { code: '+370', value: 'LT', name: 'LT - Lithuania (+370)' },
  { code: '+352', value: 'LU', name: 'LU - Luxembourg (+352)' },
  { code: '+853', value: 'MO', name: 'MO - Macau (+853)' },
  { code: '+389', value: 'MK', name: 'MK - Macedonia (+389)' },
  { code: '+261', value: 'MG', name: 'MG - Madagascar (+261)' },
  { code: '+265', value: 'MW', name: 'MW - Malawi (+265)' },
  { code: '+60', value: 'MY', name: 'MY - Malaysia (+60)' },
  { code: '+960', value: 'MV', name: 'MV - Maldives (+960)' },
  { code: '+223', value: 'ML', name: 'ML - Mali (+223)' },
  { code: '+356', value: 'MT', name: 'MT - Malta (+356)' },
  { code: '+692', value: 'MH', name: 'MH - Marshall Islands (+692)' },
  { code: '+222', value: 'MR', name: 'MR - Mauritania (+222)' },
  { code: '+230', value: 'MU', name: 'MU - Mauritius (+230)' },
  { code: '+262', value: 'YT', name: 'YT - Mayotte (+262)' },
  { code: '+52', value: 'MX', name: 'MX - Mexico (+52)' },
  { code: '+691', value: 'FM', name: 'FM - Micronesia (+691)' },
  { code: '+373', value: 'MD', name: 'MD - Moldova (+373)' },
  { code: '+377', value: 'MC', name: 'MC - Monaco (+377)' },
  { code: '+976', value: 'MN', name: 'MN - Mongolia (+976)' },
  { code: '+382', value: 'ME', name: 'ME - Montenegro (+382)' },
  { code: '+1-664', value: 'MS', name: 'MS - Montserrat (+1-664)' },
  { code: '+212', value: 'MA', name: 'MA - Morocco (+212)' },
  { code: '+258', value: 'MZ', name: 'MZ - Mozambique (+258)' },
  { code: '+95', value: 'MM', name: 'MM - Myanmar (+95)' },
  { code: '+264', value: 'NA', name: 'NA - Namibia (+264)' },
  { code: '+674', value: 'NR', name: 'NR - Nauru (+674)' },
  { code: '+977', value: 'NP', name: 'NP - Nepal (+977)' },
  { code: '+31', value: 'NL', name: 'NL - Netherlands (+31)' },
  { code: '+599', value: 'AN', name: 'AN - Netherlands Antilles (+599)' },
  { code: '+687', value: 'NC', name: 'NC - New Caledonia (+687)' },
  { code: '+64', value: 'NZ', name: 'NZ - New Zealand (+64)' },
  { code: '+505', value: 'NI', name: 'NI - Nicaragua (+505)' },
  { code: '+227', value: 'NE', name: 'NE - Niger (+227)' },
  { code: '+234', value: 'NG', name: 'NG - Nigeria (+234)' },
  { code: '+683', value: 'NU', name: 'NU - Niue (+683)' },
  { code: '+850', value: 'KP', name: 'KP - North Korea (+850)' },
  { code: '+1-670', value: 'MP', name: 'MP - Northern Mariana Islands (+1-670)' },
  { code: '+47', value: 'NO', name: 'NO - Norway (+47)' },
  { code: '+968', value: 'OM', name: 'OM - Oman (+968)' },
  { code: '+92', value: 'PK', name: 'PK - Pakistan (+92)' },
  { code: '+680', value: 'PW', name: 'PW - Palau (+680)' },
  { code: '+970', value: 'PS', name: 'PS - Palestine (+970)' },
  { code: '+507', value: 'PA', name: 'PA - Panama (+507)' },
  { code: '+675', value: 'PG', name: 'PG - Papua New Guinea (+675)' },
  { code: '+595', value: 'PY', name: 'PY - Paraguay (+595)' },
  { code: '+51', value: 'PE', name: 'PE - Peru (+51)' },
  { code: '+63', value: 'PH', name: 'PH - Philippines (+63)' },
  { code: '+64', value: 'PN', name: 'PN - Pitcairn (+64)' },
  { code: '+48', value: 'PL', name: 'PL - Poland (+48)' },
  { code: '+351', value: 'PT', name: 'PT - Portugal (+351)' },
  { code: '+1-787', value: 'PR', name: 'PR - Puerto Rico (+1-787)' },
  { code: '+1-939', value: 'PR1', name: 'PR - Puerto Rico (+1-939)' },
  { code: '+974', value: 'QA', name: 'QA - Qatar (+974)' },
  { code: '+242', value: 'CG', name: 'CG - Republic of the Congo (+242)' },
  { code: '+262', value: 'RE', name: 'RE - Reunion (+262)' },
  { code: '+40', value: 'RO', name: 'RO - Romania (+40)' },
  { code: '+7', value: 'RU', name: 'RU - Russia (+7)' },
  { code: '+250', value: 'RW', name: 'RW - Rwanda (+250)' },
  { code: '+590', value: 'BL', name: 'BL - Saint Barthelemy (+590)' },
  { code: '+290', value: 'SH', name: 'SH - Saint Helena (+290)' },
  { code: '+1-869', value: 'KN', name: 'KN - Saint Kitts and Nevis (+1-869)' },
  { code: '+1-758', value: 'LC', name: 'LC - Saint Lucia (+1-758)' },
  { code: '+590', value: 'MF', name: 'MF - Saint Martin (+590)' },
  { code: '+508', value: 'PM', name: 'PM - Saint Pierre and Miquelon (+508)' },
  { code: '+1-784', value: 'VC', name: 'VC - Saint Vincent and the Grenadines (+1-784)' },
  { code: '+685', value: 'WS', name: 'WS - Samoa (+685)' },
  { code: '+378', value: 'SM', name: 'SM - San Marino (+378)' },
  { code: '+239', value: 'ST', name: 'ST - Sao Tome and Principe (+239)' },
  { code: '+966', value: 'SA', name: 'SA - Saudi Arabia (+966)' },
  { code: '+221', value: 'SN', name: 'SN - Senegal (+221)' },
  { code: '+381', value: 'RS', name: 'RS - Serbia (+381)' },
  { code: '+248', value: 'SC', name: 'SC - Seychelles (+248)' },
  { code: '+232', value: 'SL', name: 'SL - Sierra Leone (+232)' },
  { code: '+65', value: 'SG', name: 'SG - Singapore (+65)' },
  { code: '+1-721', value: 'SX', name: 'SX - Sint Maarten (+1-721)' },
  { code: '+421', value: 'SK', name: 'SK - Slovakia (+421)' },
  { code: '+386', value: 'SI', name: 'SI - Slovenia (+386)' },
  { code: '+677', value: 'SB', name: 'SB - Solomon Islands (+677)' },
  { code: '+252', value: 'SO', name: 'SO - Somalia (+252)' },
  { code: '+27', value: 'ZA', name: 'ZA - South Africa (+27)' },
  { code: '+82', value: 'KR', name: 'KR - South Korea (+82)' },
  { code: '+211', value: 'SS', name: 'SS - South Sudan (+211)' },
  { code: '+34', value: 'ES', name: 'ES - Spain (+34)' },
  { code: '+94', value: 'LK', name: 'LK - Sri Lanka (+94)' },
  { code: '+249', value: 'SD', name: 'SD - Sudan (+249)' },
  { code: '+597', value: 'SR', name: 'SR - Suriname (+597)' },
  { code: '+47', value: 'SJ', name: 'SJ - Svalbard and Jan Mayen (+47)' },
  { code: '+268', value: 'SZ', name: 'SZ - Swaziland (+268)' },
  { code: '+46', value: 'SE', name: 'SE - Sweden (+46)' },
  { code: '+41', value: 'CH', name: 'CH - Switzerland (+41)' },
  { code: '+963', value: 'SY', name: 'SY - Syria (+963)' },
  { code: '+886', value: 'TW', name: 'TW - Taiwan (+886)' },
  { code: '+992', value: 'TJ', name: 'TJ - Tajikistan (+992)' },
  { code: '+255', value: 'TZ', name: 'TZ - Tanzania (+255)' },
  { code: '+66', value: 'TH', name: 'TH - Thailand (+66)' },
  { code: '+228', value: 'TG', name: 'TG - Togo (+228)' },
  { code: '+690', value: 'TK', name: 'TK - Tokelau (+690)' },
  { code: '+676', value: 'TO', name: 'TO - Tonga (+676)' },
  { code: '+1-868', value: 'TT', name: 'TT - Trinidad and Tobago (+1-868)' },
  { code: '+216', value: 'TN', name: 'TN - Tunisia (+216)' },
  { code: '+90', value: 'TR', name: 'TR - Turkey (+90)' },
  { code: '+993', value: 'TM', name: 'TM - Turkmenistan (+993)' },
  { code: '+1-649', value: 'TC', name: 'TC - Turks and Caicos Islands (+1-649)' },
  { code: '+688', value: 'TV', name: 'TV - Tuvalu (+688)' },
  { code: '+1-340', value: 'VI', name: 'VI - U.S. Virgin Islands (+1-340)' },
  { code: '+256', value: 'UG', name: 'UG - Uganda (+256)' },
  { code: '+380', value: 'UA', name: 'UA - Ukraine (+380)' },
  { code: '+971', value: 'AE', name: 'AE - United Arab Emirates (+971)' },
  { code: '+44', value: 'GB', name: 'GB - United Kingdom (+44)' },
  { code: '+1', value: 'US', name: 'US - United States (+1)' },
  { code: '+598', value: 'UY', name: 'UY - Uruguay (+598)' },
  { code: '+998', value: 'UZ', name: 'UZ - Uzbekistan (+998)' },
  { code: '+678', value: 'VU', name: 'VU - Vanuatu (+678)' },
  { code: '+379', value: 'VA', name: 'VA - Vatican (+379)' },
  { code: '+58', value: 'VE', name: 'VE - Venezuela (+58)' },
  { code: '+84', value: 'VN', name: 'VN - Vietnam (+84)' },
  { code: '+681', value: 'WF', name: 'WF - Wallis and Futuna (+681)' },
  { code: '+212', value: 'EH', name: 'EH - Western Sahara (+212)' },
  { code: '+967', value: 'YE', name: 'YE - Yemen (+967)' },
  { code: '+260', value: 'ZM', name: 'ZM - Zambia (+260)' },
  { code: '+263', value: 'ZW', name: 'ZW - Zimbabwe (+263)' },
];
